/** @file buildHeaders: credentials, content type and accept for one request. */
import type { ClientOptions, RequestInput } from './clientOptions';

const ACCEPT: Record<RequestInput['accept'], string> = {
  json: 'application/json', empty: 'application/json', text: 'text/markdown', bytes: '*/*',
};

function contentTypeOf(input: RequestInput): string | undefined {
  if (input.bytes !== undefined) return input.contentType ?? 'application/octet-stream';
  return input.body === undefined ? undefined : 'application/json';
}

/** Bearer token when given, else `Cookie: __Host-session=<cookie>`; `Content-Type` JSON unless bytes are sent. */
export function buildHeaders(opts: ClientOptions, input: RequestInput): Record<string, string> {
  const headers: Record<string, string> = { Accept: ACCEPT[input.accept] };
  if (opts.token !== undefined) headers.Authorization = `Bearer ${opts.token}`;
  else if (opts.cookie !== undefined) headers.Cookie = `__Host-session=${opts.cookie}`;
  const type = contentTypeOf(input);
  if (type !== undefined) headers['Content-Type'] = type;
  return headers;
}
